import * as React from 'react';

import {
  SIZE_12,
  SIZE_16,
  SIZE_20,
  SIZE_60,
} from '../../../../constants/sizes';
import { Container } from '../../../../components/Container';
import { Divider } from '../../../../components/Divider';
import { Button } from '../../../../components/Button';
import { TCityModalStep } from './CityModal';
import { SearchButton } from '../../../../components/SearchButton';

interface ICityModalInputProps {
  count: number | null;
  isCountFetching?: boolean;
  step: TCityModalStep;
  onBackClick(): void;
  onSubmit(): void;
}

export class CityModalFooter extends React.PureComponent<ICityModalInputProps> {
  public render() {
    const {
      count,
      isCountFetching,
      step,
      onBackClick,
      onSubmit,
    } = this.props;

    return (
      <Container
        position="absolute"
        right="0"
        left="0"
        bottom="0"
        height={SIZE_60}
        padding={`0 0 ${SIZE_60}`}
      >
        <Divider />
        <Container
          padding={`${SIZE_16} ${SIZE_20}`}
          display="flex"
          justifyContent="center"
          position="relative"
        >
          <Container
            position="absolute"
            top="0"
            right="0"
            left="0"
            bottom="0"
            backgroundColor="white"
            opacity={0.95}
          />
          {step === 2
          && <Container
            margin={`0 ${SIZE_12} 0 0`}
          >
            <Button type="secondary" onClick={onBackClick} >
              Назад к регионам
            </Button>
          </Container>
          }
          <SearchButton onClick={onSubmit} count={count} isCountFetching={isCountFetching} />
        </Container>
      </Container>
    );
  }
}
